export default {"src":"/_next/static/media/10-icon.93699d1a.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};